module.exports = __webpack_public_path__ + "img/marginalia-uploading.4bda4578.png";